import { useEffect, useState } from "react";
import axios from "axios";
import { ACCESS_KEY } from "../config";

function LiveBanHistory() {
  const [search, setSearch] = useState("");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const historyPerPage = 20;

  useEffect(() => {
    getLiveBanHistory();
  }, []);

  // 1. Live Ban History Fetch karne ka function
  const getLiveBanHistory = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://admin.butterlive.co.in/management/live-ban-history",
        {
          headers: {
            key: ACCESS_KEY,
          },
        }
      );
      if (response.data.status) {
        setHistory(response.data.data);
      }
    } catch (error) {
      console.log("Error fetching live ban history:", error);
    } finally {
      setLoading(false);
    }
  };

  // 2. Filter aur Pagination Logic
  const filteredHistory = history.filter((item) =>
    (item.name || "").toLowerCase().includes(search.toLowerCase()) ||
    String(item.uniqueId || "").includes(search)
  );

  const indexOfLastItem = currentPage * historyPerPage;
  const indexOfFirstItem = indexOfLastItem - historyPerPage;
  const currentHistory = filteredHistory.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredHistory.length / historyPerPage) || 1;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Live Ban History</h1>
      </div>

      <div className="top-bar">
        <input
          type="text"
          placeholder="Search Name / User ID"
          className="search-box"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <div className="table-card">
        {loading ? (
          <p style={{ padding: "20px", color: "#9ca3af" }}>Loading ban history...</p>
        ) : (
          <table width="100%" cellPadding="12" style={{ minWidth: "1200px" }}>
            <thead>
              <tr>
                <th>Sr No</th>
                <th>Name</th>
                <th>User ID</th>
                <th>Ban Duration</th>
                <th>Ban Reason</th>
                <th>Date & Time</th>
                <th>Action Type</th>
              </tr>
            </thead>

            <tbody>
              {currentHistory.length > 0 ? (
                currentHistory.map((item, index) => (
                  <tr key={item._id || index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td style={{ color: "#ff4d94", fontWeight: "600" }}>{item.name}</td>
                    <td>{item.uniqueId}</td>
                    <td>{item.duration || "—"}</td>
                    <td style={{ color: "#9ca3af" }}>{item.reason || "Violation of guidelines"}</td>
                    <td>{item.createdAt ? new Date(item.createdAt).toLocaleString() : "—"}</td>
                    <td>
                      <span className={item.actionType === "Unban" ? "status-active" : "status-banned"}>
                        {item.actionType || "Banned"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="no-data" style={{ textAlign: "center", padding: "30px", color: "#9ca3af" }}>
                    No ban history entries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}

        <div className="pagination">
          <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
            Previous
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default LiveBanHistory;
